import React, { useEffect, useRef, useState } from "react";
import Modal from "../../Common/Modal";
import IconInfo from "../../../Icons/NotificationMessage/Info";
import "./BackupNowModal.css";

type Props = {
  showPopUp: boolean;
  setShowPopUp: (show: boolean) => void;
  onBackupAction: (name: string) => void;
};

export default function SystemBackupNowPopUp({
  showPopUp,
  setShowPopUp,
  onBackupAction,
}: Props) {
  const [tbValue, setTbValue] = useState("");
  const [tbReadOnly, setTbReadOnly] = useState(false);
  const [backupNameInvalid, setBackupNameInvalid] = useState(false);
  const textField = useRef<HTMLTextAreaElement>(null);

  const maxInput: number = 100;

  useEffect(() => {
    if (showPopUp == false) setTbValue("");
  }, [showPopUp]);

  const onClickOk = () => {
    setShowPopUp(false);
    onBackupAction(tbValue);
  };

  const onClickCancel = () => {
    setShowPopUp(false);
  };

  const checkInvalidCharacter = (value: string) => {
    const invalidCharRegex = /[\\\/\:\*\?\"\<\>\|]/;
    if (invalidCharRegex.test(value)) {
      setBackupNameInvalid(true);
    } else {
      setBackupNameInvalid(false);
    }
  };

  return (
    <Modal show={showPopUp} onHide={onClickCancel} className={""}>
      <Modal.Header
        hideButtonEnabled={false}
        title="Backup Configuration"
        className="backup-now-modal-header"
      ></Modal.Header>
      <Modal.Body className="backup-now-modal-body">
        <div className="title">
          <p>Write a name for your backup below</p>
        </div>
        <textarea
          ref={textField}
          // type = "text"
          name="backup name"
          value={tbValue}
          onChange={
            tbReadOnly
              ? () => {}
              : (e) => {
                  if (e.target.value.length <= maxInput)
                    setTbValue(e.target.value);
                  checkInvalidCharacter(e.target.value);
                }
          }
          placeholder="Type here"
          style={{
            width: "100%",
            height: "80px",
            resize: "none",
            fontFamily: "Roboto",
            border: "1px solid #B4B4B4",
            borderRadius: 2,
            borderColor: backupNameInvalid ? "#c92932" : "#B4B4B4",
          }}
        />
        <div className="counter">
          {backupNameInvalid && (
            <div className="backup-now-modal-dbname-invalid">
              <IconInfo fill="#C92932" width="10" height="10" />
              <p>
                backup name can't contain any of the following characters: \ / :
                * ? : &lt; &gt; |
              </p>
            </div>
          )}
          {!backupNameInvalid && <div></div>}
          <p>
            {tbValue.length}/{maxInput}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer
        onClickOk={onClickOk}
        onClickCancel={onClickCancel}
        okButtonDisabled={
          tbValue === null || tbValue === undefined || tbValue === "" || backupNameInvalid
        }
      />
    </Modal>
  );
}
